import { useMemo } from "react";

// Deterministic pseudo-random for stable SSR-ish rendering
function seededCandles(count, seed = 42) {
  const arr = [];
  let s = seed;
  const rand = () => {
    s = (s * 9301 + 49297) % 233280;
    return s / 233280;
  };
  let last = 50;
  for (let i = 0; i < count; i++) {
    const open = last;
    const close = Math.max(10, Math.min(90, open + (rand() - 0.48) * 18));
    const high = Math.max(open, close) + rand() * 6;
    const low = Math.min(open, close) - rand() * 6;
    arr.push({ open, close, high, low });
    last = close;
  }
  return arr;
}

export default function CandlestickBg() {
  const candles = useMemo(() => seededCandles(60), []);
  // Repeat twice for seamless scroll
  const list = [...candles, ...candles];

  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none" aria-hidden>
      <div className="absolute inset-0 grid-bg opacity-40" />
      <svg
        className="absolute bottom-0 left-0 w-[200%] h-full scroll-candles opacity-60"
        viewBox={`0 0 ${list.length * 18} 100`}
        preserveAspectRatio="none"
      >
        {list.map((c, i) => {
          const x = i * 18 + 4;
          const up = c.close >= c.open;
          const top = 100 - c.high;
          const bottom = 100 - c.low;
          const bodyTop = 100 - Math.max(c.open, c.close);
          const bodyBottom = 100 - Math.min(c.open, c.close);
          const color = up ? "#10B981" : "#EF4444";
          return (
            <g key={i}>
              <line x1={x + 5} y1={top} x2={x + 5} y2={bottom} stroke={color} strokeWidth={0.6} opacity={0.6} />
              <rect
                x={x}
                y={bodyTop}
                width={10}
                height={Math.max(0.8, bodyBottom - bodyTop)}
                fill={color}
                opacity={0.7}
              />
            </g>
          );
        })}
      </svg>

      {/* Animated line graph overlay */}
      <svg className="absolute inset-0 w-full h-full opacity-30" viewBox="0 0 1200 400" preserveAspectRatio="none">
        <defs>
          <linearGradient id="lineGrad" x1="0" y1="0" x2="1" y2="0">
            <stop offset="0%" stopColor="#60A5FA" stopOpacity="0" />
            <stop offset="50%" stopColor="#60A5FA" stopOpacity="1" />
            <stop offset="100%" stopColor="#60A5FA" stopOpacity="0" />
          </linearGradient>
        </defs>
        <path
          d="M0,300 C100,260 200,320 300,250 C400,180 500,220 600,160 C700,120 800,180 900,140 C1000,110 1100,150 1200,90"
          stroke="url(#lineGrad)"
          strokeWidth="2"
          fill="none"
        />
      </svg>

      {/* Gradient orbs */}
      <div className="orb bg-blue-600" style={{ width: 500, height: 500, top: "-20%", left: "-10%" }} />
      <div className="orb bg-indigo-700" style={{ width: 600, height: 600, bottom: "-30%", right: "-10%" }} />

      {/* Vignette */}
      <div className="absolute inset-0 bg-gradient-to-b from-[#020617]/40 via-transparent to-[#020617]" />
    </div>
  );
}
